import React from 'react';
import { Formik } from 'formik';
import { Container, Row, Col, Form } from 'react-bootstrap';
import Button from '../common/button';

const AccountInfo = ({
  schema,
  currentStep,
  nextStep,
  userData,
  formData,
  handleInput,
}) => {
  return currentStep === 1 ? (
    <Container className="account-info-container">
      <Row className="mb-4">
        <Col md={12} className="p-0 mt-3">
          <p>
            To make your account secure, please create a new password to replace
            the temporary password you were given by the Javelina Admin, along
            with other details.
          </p>
        </Col>
      </Row>
      <Row>
        <Col md={12} className="p-0">
          <Formik
            validationSchema={schema}
            initialValues={{
              firstName: userData.firstName,
              middleName: userData.middleName,
              lastName: userData.lastName,
              email: userData.email,
              confirmEmail: userData.confirmEmail,
            }}
            enableReinitialize
            onSubmit={() => {
              nextStep();
            }}
          >
            {({
              values,
              touched,
              errors,
              status,
              handleSubmit,
              handleChange,
              handleBlur,
              setStatus,
              setFieldValue,
            }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col sm={6}>
                      <Form.Group className="mb-4">
                        <Form.Label className="mb-0">First Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="firstName"
                          placeholder=""
                          className={
                            status && status.firstName ? 'is-invalid' : ''
                          }
                          value={formData.firstName}
                          isInvalid={touched.firstName && errors.firstName}
                          onChange={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                          onBlur={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                          disabled
                        />
                        {status && status.firstName ? (
                          <Form.Control.Feedback
                            type="invalid"
                            className="mt-1"
                          >
                            <span>{status.firstName}</span>
                          </Form.Control.Feedback>
                        ) : (
                          errors.firstName && (
                            <Form.Control.Feedback
                              type="invalid"
                              className="mt-1"
                            >
                              <span>
                                {touched.firstName && errors.firstName}
                              </span>
                            </Form.Control.Feedback>
                          )
                        )}
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group className="mb-4">
                        <Form.Label className="mb-0">Middle Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="middleName"
                          placeholder=""
                          className={
                            status && status.middleName ? 'is-invalid' : ''
                          }
                          value={formData.middleName}
                          isInvalid={touched.middleName && errors.middleName}
                          onChange={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                          onBlur={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                          disabled
                        />
                        {status && status.middleName ? (
                          <Form.Control.Feedback
                            type="invalid"
                            className="mt-1"
                          >
                            <span>{status.middleName}</span>
                          </Form.Control.Feedback>
                        ) : (
                          errors.middleName && (
                            <Form.Control.Feedback
                              type="invalid"
                              className="mt-1"
                            >
                              <span>
                                {touched.middleName && errors.middleName}
                              </span>
                            </Form.Control.Feedback>
                          )
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <Form.Group className="mb-4">
                        <Form.Label className="mb-0">Last Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="lastName"
                          placeholder=""
                          className={
                            status && status.lastName ? 'is-invalid' : ''
                          }
                          value={formData.lastName}
                          isInvalid={touched.lastName && errors.lastName}
                          onChange={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                          onBlur={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                          disabled
                        />
                        {status && status.lastName ? (
                          <Form.Control.Feedback
                            type="invalid"
                            className="mt-1"
                          >
                            <span>{status.lastName}</span>
                          </Form.Control.Feedback>
                        ) : (
                          errors.lastName && (
                            <Form.Control.Feedback
                              type="invalid"
                              className="mt-1"
                            >
                              <span>{touched.lastName && errors.lastName}</span>
                            </Form.Control.Feedback>
                          )
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <Form.Group className="mb-4">
                        <Form.Label className="mb-0">Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder=""
                          className={status && status.email ? 'is-invalid' : ''}
                          value={formData.email}
                          isInvalid={touched.email && errors.email}
                          onChange={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                          onBlur={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                          disabled
                        />
                        {status && status.email ? (
                          <Form.Control.Feedback
                            type="invalid"
                            className="mt-1"
                          >
                            <span>{status.email}</span>
                          </Form.Control.Feedback>
                        ) : (
                          errors.email && (
                            <Form.Control.Feedback
                              type="invalid"
                              className="mt-1"
                            >
                              <span>{touched.email && errors.email}</span>
                            </Form.Control.Feedback>
                          )
                        )}
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group className="mb-4">
                        <Form.Label className="mb-0">Confirm Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="confirmEmail"
                          placeholder=""
                          className={
                            status && status.confirmEmail ? 'is-invalid' : ''
                          }
                          value={formData.confirmEmail}
                          isInvalid={
                            touched.confirmEmail && errors.confirmEmail
                          }
                          onChange={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                          onBlur={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                          disabled
                        />
                        {status && status.confirmEmail ? (
                          <Form.Control.Feedback
                            type="invalid"
                            className="mt-1"
                          >
                            <span>{status.confirmEmail}</span>
                          </Form.Control.Feedback>
                        ) : (
                          errors.confirmEmail && (
                            <Form.Control.Feedback
                              type="invalid"
                              className="mt-1"
                            >
                              <span>
                                {touched.confirmEmail && errors.confirmEmail}
                              </span>
                            </Form.Control.Feedback>
                          )
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button type="submit" className="float-right mt-2">
                        Continue
                      </Button>
                    </Col>
                  </Row>
                </Form>
              );
            }}
          </Formik>
        </Col>
      </Row>
    </Container>
  ) : null;
};

export default AccountInfo;
